import React, {useRef, useState} from "react";
import "./Formulario-style.css";
import Form from "./Form";

import { modalComponente } from "../modal";

function Formulario(props) {

  const [cpf, setCPF] = useState("");
  const [matricula, setMatricula] = useState("");
  const [token, setToken] = useState("");
  const [dataNascimento, setData] = useState("");
  const [modal, setModal] = useState(false);
  const [modalTipo, setModalTipo] = useState("");
  const toggle = () => setModal(!modal);
  const limparFormulario = () => {
    setCPF("")
    setMatricula("")
    setData("")
    setModal(!modal)
  };
  const inputRef = useRef(null);
  const showModal = (tipo) => {
    setModalTipo(tipo);
    setModal(!modal);
    return myModal();
  };

  const myModal = () => {
    if (modalTipo === "enviar") {
      return modalComponente(modal, "modal-voltar", "Enviado para processamento. Aguarde a conclusão acompanhando através da tela de campanhas", toggle, toggle, 1, inputRef);
    }
    if (modalTipo === "rascunho") {
      return modalComponente(modal, "modal-rascunho", "Rascunho salvo com sucesso!", toggle, toggle, 1, inputRef);
    }
    if (modalTipo === "voltar") {
      return modalComponente(modal, "modal-voltar", "Deseja realmente retornar a tela de campanhas? Todo o conteúdo será apagado.", toggle, salvar, 3, inputRef);
    }
    if (modalTipo === "excel-invalido") {
      return modalComponente(modal, "modal", "Arquivo inválido. Verifique o arquivo e tente novamente.", toggle, toggle, 4, inputRef);
    }
  };

  const enviar = () => {
    const cpfLimpo = cpf.replace('-', '').replace('.', '-')
    const aux = dataNascimento.split('-')
    const body = {
      cpf: cpfLimpo,
      dataNascimento: aux[2]+aux[1]+aux[0],
      matricula: matricula,
      token: token
    }
    props.saveConsulta.save(body)
    return window.location = "/diploma";
  };

  const salvar = () => {
    return showModal("rascunho");
  };

  return (
    <>
      {Form(
        cpf,
        dataNascimento,
        matricula,
        token,
        myModal,
        setCPF,
        setMatricula,
        setData,
        setToken,
        showModal,
        enviar,
        limparFormulario
      )}
    </>
  );
}

export default Formulario;
